import { render, staticRenderFns } from "./ProtocolConfirm.vue?vue&type=template&id=b2d56f32&"
import script from "./ProtocolConfirm.vue?vue&type=script&lang=js&"
export * from "./ProtocolConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports